import each from 'lodash/each';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import { eachHierarchy } from '@Hooks/LibraryInitialization/MoreUnderscore';

export function initPropertiesList(list) {
  const propertiesList = [];
  const querylets = _.filter(list, (item) => item.childrenCount === 0 || item.type === 'fact' || item.type === 'taxonomy');

  propertiesList.push(...querylets);

  list.forEach((item, index) => {
    let expandedValue = false;
    const { children } = item;

    if (children && children.length > 0 && item.type !== 'fact') {
      if (index === 0) {
        expandedValue = true;
      }
      // eslint-disable-next-line no-param-reassign
      item = { ...item, expanded: expandedValue };
      initPropertiesList(children);
    }
  });

  return propertiesList;
}

export function initSearchQueryletIndexedConstraints(list) {
  const searchQueryletIndexedConstraints = {};
  const gatherFactIndexes = (factItem) => [
    // priority array format, each priority has its own array of indexes
    // higher priority
    [factItem.displayName.toLowerCase()],
    // lower priority
    _.chain(factItem.children).map('displayName').map(_.toLower).value(),
  ];

  const gatherFieldIndexes = (fieldItem) => [
    // priority array format, but there is only one priority
    [fieldItem.displayName.toLowerCase()],
  ];

  each(list, (item) => {
    if (item.type === 'database') {
      const dbItem = item;
      const indexedConstraintsItem = {
        _databaseData: { ...dbItem, children: [] },
        _factsData: {},
        _factsIndexes: {},
        _fieldsIndexes: {},
      };

      eachHierarchy(item.children, (subItem) => {
        if (subItem.type === 'fact') {
          const factItem = subItem;

          indexedConstraintsItem._factsData[factItem.id] = factItem;
          indexedConstraintsItem._factsIndexes[factItem.id] = gatherFactIndexes(factItem);
        } else if (subItem.type === 'field') {
          const fieldItem = subItem;

          indexedConstraintsItem._fieldsIndexes[fieldItem.id] = gatherFieldIndexes(fieldItem);
        }
      });

      searchQueryletIndexedConstraints[dbItem.id] = indexedConstraintsItem;
    }
  });

  return searchQueryletIndexedConstraints;
}

// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_FAVS = [
  {
    id: 'STRUCTURE.QL',
    iconId: 'Structure',
    fullName: 'Structure',
    shortName: 'Structure',
    order: 1,
    label: 'Structure',
    isCustom: false,
    automationId: 'querybuilder-addstructure-button',
  },
  {
    id: 'Reaxys449',
    iconId: 'PeriodicTable',
    fullName: 'Molecular Formula',
    shortName: 'Molecular Formula',
    automationId: 'querybuilder-addmolecularformula-button',
    order: 2,
    label: 'Pixel',
    isCustom: true,
  },
  {
    id: 'Reaxys6',
    iconId: 'PeriodicTable',
    fullName: 'Molecular Formula',
    shortName: 'Molecular Formula',
    order: 2,
    label: 'Pixel',
    isCustom: true,
    automationId: 'querybuilder-addmolecularformula-button',
  },
  {
    id: 'Reaxys300',
    iconId: 'PeriodicTable',
    fullName: 'Molecular Formula',
    shortName: 'Molecular Formula',
    order: 2,
    label: 'Pixel',
    isCustom: true,
    automationId: 'querybuilder-addmolecularformula-button',
  },
  {
    id: 'Reaxys8',
    iconId: 'Grid',
    fullName: 'CAS Number',
    shortName: 'CAS RN',
    order: 3,
    label: 'Grid',
    isCustom: false,
    automationId: 'querybuilder-addcasrn-button',
  },
  {
    id: 'Reaxys451',
    iconId: 'Grid',
    fullName: 'CAS Number',
    shortName: 'CAS RN',
    order: 3,
    label: 'Grid',
    isCustom: false,
    automationId: 'querybuilder-addcasrn-button',
  },
  {
    id: 'Reaxys302',
    iconId: 'Grid',
    fullName: 'CAS Number',
    shortName: 'CAS RN',
    order: 3,
    label: 'Grid',
    isCustom: false,
    automationId: 'querybuilder-addcasrn-button',
  }, //
  {
    id: 'Reaxys446',
    iconId: 'CloseQuotes',
    fullName: 'Titles, Abstracts & Keywords',
    shortName: 'TI, AB & KW',
    order: 4,
    label: 'Syllabus',
    isCustom: false,
    automationId: 'querybuilder-addtiabkw-button',
  },
  {
    id: 'Reaxys3',
    iconId: 'CloseQuotes',
    fullName: 'Titles, Abstracts & Keywords',
    shortName: 'TI, AB & KW',
    order: 4,
    label: 'Syllabus',
    isCustom: false,
    automationId: 'querybuilder-addtiabkw-button',
  },
  {
    id: 'Reaxys297',
    iconId: 'CloseQuotes',
    fullName: 'Titles, Abstracts & Keywords',
    shortName: 'TI, AB & KW',
    order: 4,
    label: 'Syllabus',
    isCustom: false,
    automationId: 'querybuilder-addtiabkw-button',
  },
];

export function checkEmptyParentAfterSplice(parent) {
  const nodesList = parent;
  const array = isArray(parent) ? parent : parent.items;
  const obj = isArray(array) ? array[0] : array;

  if (isEmpty(array)) {
    const index = nodesList.indexOf(obj);

    if (index !== -1) {
      nodesList.splice(index, 1);
    }
  }
  return nodesList;
}
